import { toast } from 'sonner'

import { Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { useMatchReceipt } from '../../hooks/useMatchReceipt'

// We pass in substantiationId and blobId to match the receipt
export function MatchReceiptButton ({
  substantiationId,
  blobId,
}: {
  substantiationId: string;
  blobId: string;
}) {
  const { reload } = useWindowLocation()

  const matchReceiptMutation = useMatchReceipt({ substantiationId, blobId })

  const handleClick = () => {
    matchReceiptMutation.mutate(
      undefined,
      {
        onSuccess: async () => {
          // Refresh the page here so that on the view picks up the attachments to display
          // When this page is migrated to react this should be resolved
          reload()
        },
        onError: (error: any) => {
          console.error('Failed to match receipt:', error)
          toast.error('Failed to match receipt')
        },
      }
    )
  }

  return (
    <>
      <Button
        type='button'
        variant='secondary'
        onClick={handleClick}
      >
        Match
      </Button>
    </>

  )
}
